import { useState, useEffect } from 'react';
import css from './PublishGalleryCheckbox.module.scss';

interface PublishGalleryCheckboxProps {
	onChange: (isChoiced: boolean) => void;
	isChoiced: boolean;
}

const PublishGalleryCheckbox = ({ onChange, isChoiced }: PublishGalleryCheckboxProps) => {
	const [localChoiced, setLocalChoiced] = useState(isChoiced);

	useEffect(() => {
		setLocalChoiced(isChoiced);
	}, [isChoiced]);

	const handleCheckboxChange = () => {
		setLocalChoiced((prevChoiced) => {
			const newChoicedState = !prevChoiced;
			onChange(newChoicedState);
			return newChoicedState;
		});
	};

	return (
		<>
			<div
				className={css.wrapper}
				role="presentation"
			>
				<p className={css.text}>Опубликовать в галерее</p>
				<div
					className={css.checkbox}
					role="presentation"
					onClick={handleCheckboxChange}
				>
					{localChoiced && (
						<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M11.3337 1L4.00033 8.33333L0.666992 5"
								stroke="#0075FF"
								strokeWidth="1.33333"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</div>
			</div>
			<p>Модуль будет доступен на всех тарифах</p>
		</>
	);
};

export default PublishGalleryCheckbox;
